class LogOutJobService {
  constructor() {
    this.token = 'tokenjob';
  }
  resources = () => ({
    cerrarSesion: {
      uri: `/v1/logout`,
      method: ['get']
    }
  });
}

export default LogOutJobService;
